import React, { useRef } from "react"
import { Input } from "./Input"

export const OtpInput = ({ value, onChange, disabled = false }) => {
  const inputRefs = useRef([])

  const handleChange = (index, inputValue) => {
    const val = inputValue
    if (!/^\d*$/.test(val)) return // Only allow digits

    const newOtp = value.split("")
    newOtp[index] = val.slice(-1) // Take only the last digit
    onChange(newOtp.join(""))

    // Auto-focus next input
    if (val && index < 3 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus()
    }
  }

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      !value[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus()
    }
  }

  const handlePaste = e => {
    e.preventDefault()
    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 4)
    onChange(pastedData.padEnd(4, ""))

    // Focus the next empty input or the last one
    const nextEmptyIndex = pastedData.length < 4 ? pastedData.length : 3
    if (inputRefs.current[nextEmptyIndex]) {
      inputRefs.current[nextEmptyIndex].focus()
    }
  }

  return (
    <div className="otp-boxes-container">
      {[0, 1, 2, 3].map(index => (
        <Input
          key={index}
          ref={el => (inputRefs.current[index] = el)}
          type="tel"
          inputMode="numeric"
          maxLength={1}
          value={value[index] || ""}
          onChange={e => handleChange(index, e.target.value)}
          onKeyDown={e => handleKeyDown(index, e)}
          onPaste={index === 0 ? handlePaste : undefined}
          disabled={disabled}
          className="otp-box"
          aria-label={`OTP digit ${index + 1}`}
        />
      ))}
    </div>
  )
}
